import { createStore } from 'vuex'

// 从 sessionStorage 中读取数据
const getSavedState = () => {
  try {
    const savedState = sessionStorage.getItem('requirementList')
    return savedState ? JSON.parse(savedState) : []
  } catch (error) {
    console.error('Error reading from sessionStorage:', error)
    return []
  }
}

// 从 sessionStorage 中读取新功能信息
const getSavedNewFunctionInfo = () => {
  try {
    const savedInfo = sessionStorage.getItem('newFunctionInfo')
    return savedInfo
      ? JSON.parse(savedInfo)
      : {
          question: [],
          funcType: 'template'
        }
  } catch (error) {
    console.error('Error reading new function info from sessionStorage:', error)
    return {
      question: [],
      funcType: 'template'
    }
  }
}

export default createStore({
  state: {
    sourceUrl: '',
    requirementList: getSavedState(),
    newFunctionInfo: getSavedNewFunctionInfo()
  },
  getters: {
  },
  mutations: {
    setRequirementList (state, obj) {
      state.requirementList = obj
      // 保存到 sessionStorage
      try {
        sessionStorage.setItem('requirementList', JSON.stringify(obj))
      } catch (error) {
        console.error('Error saving to sessionStorage:', error)
      }
    },
    setSourceUrl (state, url) {
      state.sourceUrl = url
    },
    setNewFunctionInfo (state, info) {
      state.newFunctionInfo = info
      // 保存到 sessionStorage
      try {
        sessionStorage.setItem('newFunctionInfo', JSON.stringify(info))
      } catch (error) {
        console.error('Error saving new function info to sessionStorage:', error)
      }
    },
    updateNewFunctionInfo (state, updatedQuestion) {
      state.newFunctionInfo.question = updatedQuestion
      // 保存到 sessionStorage
      try {
        sessionStorage.setItem('newFunctionInfo', JSON.stringify(state.newFunctionInfo))
      } catch (error) {
        console.error('Error updating new function info in sessionStorage:', error)
      }
    }

  },
  actions: {
  },
  modules: {
  }
})
